import { defineComponent as E, computed as O, useAttrs as S, createBlock as x, openBlock as h, unref as z, normalizeStyle as $, normalizeClass as b, withCtx as g, createElementVNode as P, mergeProps as R, renderSlot as v, createElementBlock as A, createCommentVNode as H, normalizeProps as C, guardReactiveProps as w } from "vue";
import "@popperjs/core";
import { RevPopover as I } from "@ds/components/Popover";
import { omit as M } from "../../utils/omit.js";
import { tw as t } from "../../utils/tailwind.js";
const F = /* @__PURE__ */ E({
  name: "RevTooltip",
  inheritAttrs: !1,
  __name: "Tooltip",
  props: {
    contentClassNames: { default: "" },
    modifiers: { default: void 0 },
    position: { default: "top" },
    shouldHideOnClickOutside: { type: Boolean, default: !0 },
    shouldShowOnMount: { type: Boolean, default: !1 },
    triggerElementId: { default: void 0 },
    withCaret: { type: Boolean, default: !0 }
  },
  setup(y) {
    const a = y, k = O(() => M(S(), ["class", "style"])), N = (e) => {
      const r = e.split("-", 1)[0], o = a.withCaret ? {
        top: t`mb-8`,
        bottom: t`mt-8`,
        left: t`mr-8`,
        right: t`ml-8`
      }[r] : "";
      return [
        t`bg-overlap-default-low text-static-default-mid mood-inverse rounded-sm body-2 relative inline-block max-w-224 px-16 py-12 text-center`,
        o,
        a.contentClassNames
      ];
    }, B = (e) => {
      if (!a.withCaret)
        return "";
      const r = t`border-t-overlap-default-low -bottom-6 border-t-6`, o = t`border-b-overlap-default-low -top-6 border-b-6`, n = t`border-l-overlap-default-low -right-6 border-l-6`, i = t`border-r-overlap-default-low -left-6 border-r-6`, s = t`border-x-6 border-solid border-x-transparent`, d = t`left-[calc(50%-6px)]`, p = t`left-12`, m = t`left-[calc(100%-12px)]`, l = t`border-y-6 border-solid border-y-transparent`, c = t`top-[calc(50%-6px)]`, u = t`top-12`, f = t`top-[calc(100%-12px)]`;
      return [
        t`absolute`,
        {
          top: [r, s, d],
          "top-start": [r, s, p],
          "top-end": [r, s, m],
          bottom: [o, s, d],
          "bottom-start": [o, s, p],
          "bottom-end": [o, s, m],
          left: [n, l, c],
          "left-start": [n, l, u],
          "left-end": [n, l, f],
          right: [i, l, c],
          "right-start": [i, l, u],
          "right-end": [i, l, f]
        }[e]
      ];
    };
    return (e, r) => (h(), x(z(I), {
      class: b(e.$attrs.class),
      "content-class-names": "w-max",
      modifiers: e.modifiers,
      position: e.position,
      "should-hide-on-click-outside": e.shouldHideOnClickOutside,
      "should-show-on-mount": e.shouldShowOnMount,
      style: $(e.$attrs.style),
      "trigger-element-id": e.triggerElementId
    }, {
      trigger: g((o) => [
        v(e.$slots, "trigger", C(w(o)))
      ]),
      content: g((o) => [
        P("div", R(k.value, {
          class: N(o.position)
        }), [
          v(e.$slots, "default", C(w(o))),
          e.withCaret ? (h(), A("div", {
            key: 0,
            class: b(B(o.position)),
            "data-popper-arrow": ""
          }, null, 2)) : H("", !0)
        ], 16)
      ]),
      _: 3
    }, 8, ["class", "modifiers", "position", "should-hide-on-click-outside", "should-show-on-mount", "style", "trigger-element-id"]));
  }
});
export {
  F as default
};
